module.exports = __webpack_public_path__ + "img/2020_11_22_jelly_bean_creature.a87f438c.jpg";